module.exports = __webpack_public_path__ + "static/media/review_bg.3fccf848.svg";